import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

/**
 * A read the record page or its drawer needs that failed: "Couldn't load …" as the heading, what went
 * wrong beneath it, and a Retry, in the words and the shape of `docs/software-design/
 * table-empty-states.md`. The kind page draws its holders' failure the same way.
 */
export default function RecordLoadFailure(props: Readonly<{ title: string; detail?: string; onRetry: () => void }>) {
  return (
    <Paper variant="outlined" role="alert" sx={{ p: 3, display: "grid", justifyItems: "center", gap: 1, textAlign: "center" }}>
      <ErrorOutlineIcon color="error" aria-hidden />
      <Typography component="h2" variant="h6">
        {props.title}
      </Typography>
      {props.detail && (
        <Typography color="text.secondary" variant="body2">
          {props.detail}
        </Typography>
      )}
      <Button variant="outlined" startIcon={<RefreshIcon />} onClick={props.onRetry}>
        Retry
      </Button>
    </Paper>
  );
}
